import $  from 'jquery';

function initModals() {
    $(document).ready(function(){
        $('.popup').each(function(){
            let $modal = $(this);
            let id = $modal.attr('id');
            let modalBtn = $('a[href="#' + id + '"]');

            // Click event to show the modal
            modalBtn.on('click', function(e) {
                e.preventDefault();  // prevent default anchor behavior
                $modal.fadeIn();    // use jQuery to show the modal
            });

            // Closing modal with the close button
            $modal.find('.close').on('click', function(e) {
                e.preventDefault();  // prevent default button behavior
                $modal.fadeOut();   // use jQuery to hide the modal
            });

            // Closing modal when clicking on the overlay
            $(document).on('click', function(e) {
                if ($(e.target).is($modal) || $(e.target).is('.popup-inner')) {
                    $modal.fadeOut();  // use jQuery to hide the modal
                }
            });
        });
    });
}

export { initModals };
